import { createContext } from "@wordpress/element";

const WidgetContext = createContext(null);

export default WidgetContext;
